// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__zJBWx","Layout--no-padding":"styles_Layout--no-padding__tNMW0"};